import {
  generateDefaultFlashSaleBarStyle,
  generateDefaultPrimaryCallToActionButtonStyle,
  generateDefaultProductDetailsPageTabBarStyle,
  generateDefaultSecondaryCallToActionButtonStyle,
  generateDefaultTopLeaderBoardBanner,
  generateRemainingStockTextStyle,
} from '../SalesChannelEditorAppearance/common';

const defaultContent = {
  topLeaderBoardBanner: generateDefaultTopLeaderBoardBanner(),
  enableRemainingStockTextStyle: false,
  productDetailsPageTabBarStyle: generateDefaultProductDetailsPageTabBarStyle(),
  flashSaleBarStyle: generateDefaultFlashSaleBarStyle(),
  primaryCallToActionButtonStyle:
    generateDefaultPrimaryCallToActionButtonStyle(),
  secondaryCallToActionButtonStyle:
    generateDefaultSecondaryCallToActionButtonStyle(),
  remainingStockTextStyle: generateRemainingStockTextStyle(),
};

export default {
  pc: defaultContent,
  tablet: defaultContent,
  mobile: defaultContent,
};
